"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemHeadline = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_lines_ellipsis_1 = tslib_1.__importDefault(require("react-lines-ellipsis"));
var responsiveHOC_1 = tslib_1.__importDefault(require("react-lines-ellipsis/lib/responsiveHOC"));
var ResponsiveEllipsis = responsiveHOC_1.default()(react_lines_ellipsis_1.default);
var DashboardItemHeadlineContainer_1 = require("./DashboardItemHeadlineContainer");
exports.DashboardItemHeadline = function (_a) {
    var title = _a.title, clientHeight = _a.clientHeight;
    // memoize the Truncate render as it is quite expensive
    var truncatedTitlePart = react_1.useMemo(function () {
        return (react_1.default.createElement(ResponsiveEllipsis, { maxLine: 2, ellipsis: "...", className: "item-headline-inner s-headline", text: title }));
    }, [title]);
    return (react_1.default.createElement(DashboardItemHeadlineContainer_1.DashboardItemHeadlineContainer, { clientHeight: clientHeight }, truncatedTitlePart));
};
//# sourceMappingURL=DashboardItemHeadline.js.map